var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "person_svg__Person",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.97 59.97"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person_svg__cls-1{fill:none;stroke:#0000f0;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "person_svg__cls-1",
    d: "M35 58.55a29 29 0 10-5 .45M22.26 21.4a7.89 7.89 0 112.37 4.24",
    transform: "translate(-.02 -.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "person_svg__cls-1",
    d: "M30 47h13.5V36.42A23.71 23.71 0 0030 32.56a23.66 23.66 0 00-13.49 3.86V47",
    transform: "translate(-.02 -.02)"
  })));
}
export default SvgPerson;